import { Gender, GenderFlag } from '@/ApiClient';

export const genders = {
  1: {
    value: Gender.Men,
    name: 'Men',
    icon: 'men',
  },
  2: {
    value: Gender.Women,
    name: 'Women',
    icon: 'ladies',
  },
  4: {
    value: Gender.Kids,
    name: 'Kids',
    icon: 'boysGirls',
  },
  8: {
    value: Gender.Babies,
    name: 'Babies',
    icon: 'babies',
  },
} as const;

export const genderKeys: readonly Gender[] = [Gender.Men, Gender.Women, Gender.Kids, Gender.Babies] as const;
export const genderList = genderKeys.map((key) => ({ key, ...genders[key] }));

export const keyToGender = (key: Gender) => ({ key, ...genders[key] });
export const keysToGenders = (keys: Gender[]) => {
  // All genders - let's combine them into one
  if (keys.length > 3) {
    return [
      {
        key: 0,
        name: 'All',
        icon: genders[4].icon,
      },
    ];
  }

  return keys.map(keyToGender);
};

export function genderFlagToArray(flag: GenderFlag): Gender[] {
  const result: Gender[] = [];
  if (flag & 1) result.push(Gender.Men);
  if (flag & 2) result.push(Gender.Women);
  if (flag & 4) result.push(Gender.Kids);
  if (flag & 8) result.push(Gender.Babies);
  return result.sort();
}

export function genderArrayToFlag(genders: Gender[]): GenderFlag {
  let flag = 0;
  if (genders.includes(Gender.Men)) flag |= 1;
  if (genders.includes(Gender.Women)) flag |= 2;
  if (genders.includes(Gender.Kids)) flag |= 4;
  if (genders.includes(Gender.Babies)) flag |= 8;
  return flag as GenderFlag;
}

export function genderArraysEqual(a: Gender[], b: Gender[]): boolean {
  if (a.length !== b.length) return false;
  const sortedA = [...a].sort();
  const sortedB = [...b].sort();
  return sortedA.every((val, idx) => val === sortedB[idx]);
}
